import { render, staticRenderFns } from "./m-color-icons.vue?vue&type=template&id=6ba9aff8"
import script from "./m-color-icons.vue?vue&type=script&lang=js"
export * from "./m-color-icons.vue?vue&type=script&lang=js"
import style0 from "./m-color-icons.vue?vue&type=style&index=0&id=6ba9aff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports